import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';

import { withRouter } from 'react-router';
import { MARKETING_GUIDELINES_MENU } from '../core/MenuComponent/MenuConstants';

import MarketingComponent from './marketingComponents/MarketingComponent';

import './marketingGuidelines.scss';

class MarketingGuidelinesComponent extends React.Component {
    getMenuItems = (menuItems) => Object.keys(menuItems).map((keyItem) => {
        const menuItem = menuItems[keyItem];
        const { params } = this.props.match;

        return {
            ...menuItem,
            url: `/marketing/${keyItem}`,
            active: params.menuItem === keyItem,
        };
    })

    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        return <div className="Developer-sdk-component container">
            <div id="profile" className="profile-component container">
                <div className="content">
                    <MarketingComponent
                        menuTitle="MARKETING GUIDELINES"
                        menuItems={this.getMenuItems(MARKETING_GUIDELINES_MENU)}
                    />
                </div>
            </div>
        </div>;
    }
}

MarketingGuidelinesComponent.propTypes = {
    match: PropTypes.object.isRequired,
};

export default withRouter(MarketingGuidelinesComponent);



// WEBPACK FOOTER //
// ./src/components/marketingGuidelines/marketingGuidelinesComponent.js